import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { Testimony } from '../../../models/entities/testimony/testimony.entity';
import { ModalService } from '../../../../core/services/modal.service';

@Component({
  selector: 'app-testimony-card',
  templateUrl: './testimony-card.component.html',
  styleUrls: ['./testimony-card.component.scss'],
})
export class TestimonyCardComponent implements OnInit, AfterViewInit {
  @Input() testimony: Testimony;
  @ViewChild('testimonyMessage') testimonyMessage: ElementRef<HTMLElement>;

  isFullyDisplayed = false;
  showToggle: boolean;

  constructor(public modalService: ModalService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showToggle =
        this.testimonyMessage.nativeElement.clientHeight <
        this.testimonyMessage.nativeElement.scrollHeight;
    });
  }
}
